export const MaterialIconMode = Object.freeze({
    MATERIAL_ICONS: "MATERIAL_ICONS",
    MATERIAL_SYMBOLS_OUTLINED: "MATERIAL_SYMBOLS_OUTLINED",
});
